import { Menu, Typography} from 'antd';
import type { MenuProps } from 'antd';
import { AppstoreOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
type MenuItem = Required<MenuProps>['items'][number];

const { Title } = Typography;

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: 'group',
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}

const LeftBarItems = (t: (key: string) => string): MenuItem[] => [
  // getItem(t("productCenter.productlist.title"), 'sub1', <AppstoreOutlined />, [
    getItem(t("page.product.categories.capacitor.title"), 'sub1', null, [
      getItem(<Link to="/products-mlcc">{t("page.product.categories.mlcc.title")}</Link>, '1'),
      getItem(<Link to="/products-aluminum">{t("page.product.categories.aluminum.title")}</Link>, '2'),
    ]),
    getItem(t("page.product.categories.inductorpro.title"), 'sub2', null, [
      getItem(<Link to="/products-ferrite">{t("page.product.categories.ferrite.title")}</Link>, '3'),
      getItem(<Link to="/products-inductor">{t("page.product.categories.inductor.title")}</Link>, '5'),
    ]),
    getItem(t("page.product.categories.ceramicpro.title"), 'sub3', null, [
      getItem(<Link to="/products-ceramic">{t("page.product.categories.ceramic.title")}</Link>, '4'),
      getItem(<Link to="/products-fbarsaw">{t("page.product.categories.fbar.title")}</Link>, '6'),
    ]),
    getItem(t("page.product.categories.connector.title"), 'sub4', null, [
      getItem(<Link to="/products/connector/ConnectorBTB">{t("page.product.categories.connector.connectorbtb")}</Link>, '7'),
      getItem(<Link to="/products/connector/ConnectorZIF">{t("page.product.categories.connector.connectorzif")}</Link>, '8'),
      getItem(<Link to="/products/connector/ServicePlug">{t("page.product.categories.connector.serviceplug")}</Link>, '9'),
      getItem(<Link to="/products/connector/ConnectorWTB">{t("page.product.categories.connector.connectorwtb")}</Link>, '10'),
      getItem(<Link to="/products/connector/ConnectorMC">{t("page.product.categories.connector.connectormc")}</Link>, '11'),
      getItem(<Link to="/products/connector/ConnectorAuto">{t("page.product.categories.connector.connectorauto")}</Link>, '12'),
    ]),
  // ]),
  // getItem('', 'sub2', <MailOutlined />, [
  // ])
];

export default function LeftBar() {
  const { t } = useTranslation(); 
  const location = useLocation();
  const items = LeftBarItems(t); 
  const selectedKeys = useMemo(() => {
  const pathname = location.pathname;
    
    // 定义路径到菜单key的映射
    const pathToKeyMap: Record<string, string> = {
      '/products-mlcc': '1',
      '/products-aluminum': '2',
      '/products-ferrite': '3',
      '/products-inductor': '5',
      '/products-ceramic': '4',
      '/products-fbarsaw': '6',
      '/products/connector/ConnectorBTB': '7',
      '/products/connector/ConnectorZIF': '8',
      '/products/connector/ServicePlug': '9',
      '/products/connector/ConnectorWTB': '10',
      '/products/connector/ConnectorMC': '11',
      '/products/connector/ConnectorAuto': '12',
    };

    // 检查当前路径是否匹配任何产品页面
    for (const [path, key] of Object.entries(pathToKeyMap)) {
      if (pathname === path || pathname.startsWith(path + '/')) {
        return [key];
      }
    }

    return [];
  }, [location.pathname]);
  return (
    <div className='left-bar' style={{ height: '100%', backgroundColor: '#ffffff' }}>
      <Title className='bg-light p-10 pt-20 pb-20' level={3}><AppstoreOutlined className='mr-5' /> {t("productCenter.productlist.title")}</Title>
      <Menu
        mode="inline"
        // 将 'capacitor' 添加到 defaultOpenKeys 数组中
        defaultOpenKeys={['sub1', 'sub2', 'sub3', 'sub4']} 
        selectedKeys={selectedKeys}
        style={{ borderRight: 0 }}
        items={items}
      />
    </div>
  );
}
